export const BUSINESS_HUB_ROUTES = {
  A: "/business-overview",
  B: "/business-requests",
  C: "/user-management",
  D: "/product-management",
  E: "/analytics",
  F: "/company-settings",
  G: "/analytics-preferences",
  H: "/promotions-and-marketing",
  I: "/payment",
  J: "/request-withdrawal",
  K: "/buy-credits",
  L: "/wallet",
  M: "/orders",
  N: "/delivery-management",
};

export const BUSINESS_HUB_ROUTE_KEYS = Object.entries(
  BUSINESS_HUB_ROUTES,
).reduce((routes, [key, route]) => {
  routes[route] = key;
  return routes;
}, {
  "/Qr-code-management": "D",
  "/create-bulk-qr-code": "D",
  "/create-single-qr-code": "D",
  "/product-catalog": "D",
  "/product-catalog/details": "D",
  "/product-submissions": "D",
  "/active-promotion": "H",
  "/create-campaign": "H",
  "/featured-placement": "H",
});

export const getRouteForActiveKey = (activeKey) =>
  BUSINESS_HUB_ROUTES[activeKey] || BUSINESS_HUB_ROUTES.C;

export const getActiveKeyForPath = (pathname) =>
  BUSINESS_HUB_ROUTE_KEYS[pathname] || null;
